// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3Q7GW","consentsList":"PatientConsents_consentsList__1p9ta","consentsListEmpty":"PatientConsents_consentsListEmpty__1QUmF"};